import React, { useState } from 'react';
import CpcbLogo from '../assets/image/golden_jubilee.jpg'
import kumbhlogo from '../assets/image/kumbh-logo.png'
import MoefccLogo from '../assets/image/moef-logo-right.png'
import IndiaEmblem from '../assets/image/logo-india.9bec2f9c3f7ffa42dbc6.png'
import { Row, Col } from 'react-bootstrap'; // For Row and Col from Bootstrap
import "../assets/css/home-style.css";

import { Link, useLocation } from 'react-router-dom';

const About = () => {
    const location = useLocation();

    return (
        <div className="home-page">


            <Row className="align-items-center py-2">
                <Col md={3} className="text-center">
                    <img
                        src={IndiaEmblem}
                        alt="India Emblem"
                        style={{
                            // height: '70px',
                            width: '60px',
                            backgroundColor: 'white',
                            padding: '5px',
                            objectFit: 'contain',
                        }}
                        className="me-2"
                    />
                    <img
                        src={CpcbLogo}
                        alt="CPCB Logo"
                        style={{
                            // height: '100px',
                            width: '120px',
                            backgroundColor: 'white',
                            padding: '5px',
                            objectFit: 'contain',
                        }}
                        className="me-2"
                    />
                    <img
                        src={MoefccLogo}
                        alt="MoEFCC Logo"
                        style={{
                            // height: '70px',
                            width: '90px',
                            backgroundColor: 'white',
                            padding: '5px',
                            objectFit: 'contain',
                            marginLeft: "-15px"
                        }}
                        className="me-2"
                    />
                </Col>

                <Col className='text-center kumbh-text'>
                    <div className='kumbhlogo'>
                        <img src={kumbhlogo} style={{ width: "90px", fontWeight: 700 }} />
                    </div>

                    <div className='kumbhtext'>
                        <h2>Maha Kumbh</h2>
                        <p>(Water Quality Data)</p>
                    </div>
                </Col>

                <Col md={3} className='text-end' style={{ marginRight: '20px' }}>
                    <h3 style={{ marginBottom: '5px' }}>Central Pollution Control Board</h3>
                    <p>Ministry of Environment, Forest and Climate Change<br />
                        Government of India
                    </p>
                </Col>
            </Row>

            <Row className="header-nav">
                <Col className="text-center">
                    <div className='container-fluid px-4 px-lg-5' >
                        <ul>
                            <li><Link to='/' className={`${location.pathname === "/" ? "active" : ""}`}>Home</Link></li>
                            <li><Link to='about' className={`${location.pathname === "/about" ? "active" : ""}`} >Kumbh Mela</Link></li>
                            <li><Link to='/login' >Login</Link></li>
                        </ul>
                    </div>
                </Col>
            </Row>


            <div className="container-fluid px-4 px-lg-5 content-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className='box'>
                            <h4>The Symbolism of the Kumbh</h4>
                            <p>
                                At the core of the Maha Kumbh Mela lies the symbolic "Kumbh" or sacred pot, representing the human form and the eternal quest for spiritual awakening. According to Hindu mythology, the Kumbh emerged during the churning of the cosmic ocean, containing the divine nectar, "amrita."
                                This metaphorical vessel signifies the sacred essence within every individual. The pilgrimage to the Maha Kumbh transcends a physical journey, becoming a path of self-exploration and a celebration of the sanctity inherent in all beings.
                            </p>
                        </div>
                        <div className='box'>
                            <h4>The Sacred Dip: A Ritual of Renewal</h4>
                            <p>
                                The act of taking a holy dip in the sacred rivers—Ganges, Yamuna, and Saraswati—is central to the Kumbh Mela experience. More than a ritual, it symbolizes spiritual purification, washing away impurities of the body and soul while renewing one's connection with the divine.
                                This act underscores the transformative power of water, a universal emblem of purity and life. Pilgrims immerse themselves, seeking not just physical cleansing but a rejuvenation of the spirit and a rekindling of their inner divinity.
                            </p>
                        </div>
                        <div className='box'>
                            <h4>Unity in Diversity: A Gathering of Souls</h4>
                            <p>
                                The Kumbh Mela epitomizes the principle of unity in diversity, weaving a tapestry of cultures, languages, and traditions. It fosters a sense of universal brotherhood, uniting people from various backgrounds in shared spirituality.
                            </p>
                            <p>
                                In a divided world, this congregation serves as a reminder that beneath our differences lies a shared human journey, bound by the collective pursuit of truth and enlightenment.
                            </p>
                        </div>
                        <div className='box'>
                            <h4>Cultural Extravaganza: Beyond Rituals</h4>
                            <p>
                                The Maha Kumbh Mela is not just a religious gathering but a vibrant cultural spectacle. Amidst prayers and rituals, the event pulsates with the melodies of traditional music, the vibrancy of cultural performances, and the rhythms of sacred dances.
                            </p>
                            <p>
                                Artisans and performers from across the nation showcase India’s rich heritage, turning the Kumbh Mela into a confluence of spiritual and cultural expression. It is a unique opportunity to participate in rituals while immersing oneself in the living culture of the nation.
                            </p>
                        </div>
                        <div className='box'>
                            <h4>A Global Pilgrimage: Harmony Across Borders</h4>
                            <p>
                                In the modern era, the Maha Kumbh Mela has evolved into a global spiritual event. Pilgrims from around the world converge at this sacred site, transcending geographical and cultural boundaries. This global participation highlights its universal appeal, fostering a sense of harmony and shared spiritual aspirations.
                            </p>
                            <p>
                                The Mela becomes a meeting ground for diverse perspectives, enriching the event with the collective wisdom of seekers from across the globe.
                            </p>
                        </div>
                        <div className='box'>
                            <h4>The Inner Journey: A Pilgrimage of the Soul</h4>
                            <p>
                                Beyond its physical and cultural dimensions, the Maha Kumbh Mela is a profound inner journey. It is a quest for self-discovery, a cleansing of the soul, and a celebration of our shared humanity. Amidst the vast congregation, individuals seek personal connections with the divine.
                            </p>
                            <p>
                                The Maha Kumbh Mela is a timeless symbol of the human pursuit of the sacred—a spiritual symphony that transcends time and space. In 2025, the sacred grounds of Prayagraj beckon all seekers to embark on this extraordinary journey of the soul.
                            </p>

                        </div>
                    </div>
                </div>
            </div>


            <Row className="align-items-center py-2 footer">
                <Col className="text-center ">
                    <p>Designed and Developed by @CPCB</p>
                </Col>
            </Row>
        </div>
    );
};

export default About;
